// B2 (agent-surface-consistency): editing an agent (model / prompt / toolsets /
// bindings / tree) is gated at developer+ on the backend (require_developer on
// PUT /agents, PUT /tree, and the /bindings endpoints). The UI must use the SAME
// bar so it never offers an edit control that a supervisor's or business_user's
// save would 403 on. Hierarchy: owner > administrator > developer > supervisor >
// business_user — so "can edit" excludes supervisor AND business_user.
export const canEditAgent = (role) =>
  !["business_user", "supervisor"].includes(role);
